export default __webpack_public_path__ + "static/media/hackerrank.9cab4ec6.png";